module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "create-category"
  }, [_c('h1', [_vm._v("Create A new category")]), _vm._v(" "), _c('div', [_c('form', [(_vm.showMsg) ? _c('div', [_vm._m(0)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getLangsValue), function(lang, key) {
    return _c('div', {
      staticClass: "input-category",
      staticStyle: {
        "margin": "10px 0"
      }
    }, [_c('label', [_vm._v("Category "), _c('span', {
      staticClass: "uppercase"
    }, [_vm._v(_vm._s(lang.label))]), _vm._v(" :\n                ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (lang.value),
        expression: "lang.value",
        modifiers: {
          "trim": true
        }
      }],
      key: key,
      staticClass: "textfield",
      attrs: {
        "type": "text",
        "id": key,
        "name": lang.value
      },
      domProps: {
        "value": (lang.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          lang.value = $event.target.value.trim()
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addCategory(_vm.action, _vm.getLangsValue);
      }
    }
  }, [_vm._v("Create")])], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_c('strong', [_vm._v("Probleme de creation d'une nouvelle categorie")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19299de5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/categories/actions/CreateCategory.vue
// module id = 3041
// module chunks = 0